import styled from 'styled-components'

export const QuickLink = styled.a`
	display: block;
	border-bottom: 1px solid ${({ theme }) => theme.colors.borderGray};
	color: ${({ theme }) => theme.colors.primary};
	padding: 15px 0px;
	text-decoration: none;
	font-size: 14px;
	&:last-child {
		border-bottom: none;
	}
`

export const QuickLinks = styled.div`
	border: 1px solid ${({ theme }) => theme.colors.borderGray};
	padding: 20px;
	margin-top: 20px;
	width: 260px;
	h3 {
		margin-bottom: 15px;
		font-weight: normal;
		font-size: 16px;
	}
`
